import isUTCDateString from './isUTCDateString';

const formatUTCDateString = (utcDateString: string): string => {
  // ensures correct utc date format: YYYY-MM-DD:T00:00:00Z
  if (!isUTCDateString(utcDateString)) {
    return '';
  }

  // extract date portion
  const date = utcDateString.substr(0, 10).split('-');

  // output in DD/MM/YYYY format
  return `${date[2]}/${date[1]}/${date[0]}`;
};

export default formatUTCDateString;
